import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm, salvar
} from './despesaActions';

class DespesaForm extends Component {

	state = {

	}

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
						
							<LabelAndInputDate
								maxWidth={180}
								name='data_despesa'
								label='Data de Registro *' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								value={this.props.formularioValues.data_despesa}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_despesa: value
									});
								}} />
								
							<LabelAndInputDate
								maxWidth={180}
								name='data_vencimento'
								label='Data de Vencimento' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								value={this.props.formularioValues.data_vencimento}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_vencimento: value
									});
								}} />
							
							<LabelAndInputDate
								maxWidth={180}
								name='data_pagamento'
								label='Data de Pagamento' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								value={this.props.formularioValues.data_pagamento}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_pagamento: value
									});
								}} />

							<Field
								name='id_empresa'
								component={Select}
								options={this.props.listaEmpresa}
								label='Empresa *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								name='id_centro_custo'
								component={Select}
								options={this.props.listaCentroCusto}
								label='Centro de Custo *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								name='id_fornecedor'
								component={Select}
								options={this.props.listaFornecedor}
								label='Fornecedor *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								name='id_analitica'
								component={Select}
								options={this.props.listaAnalitica}
								label='Analítica *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />								
							
							<Field
								name='id_forma_pagamento'
								component={Select}
								options={this.props.listaFormaPagamento}
								label='Forma de Pagamento *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />

							<Field
								name='id_origem'
								component={Select}
								options={this.props.listaOrigem}
								label='Origem *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />

							<Field
								name='valor'
								component={LabelAndInputNumber}
								label='Valor *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly}
								mask={2} />

							<Field
								name='observacao'
								component={LabelAndInput}
								label='Observação' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
							
							{this.props.formularioValues.nome_usuario_inclusao &&
							<Field
								name='nome_usuario_inclusao'
								component={LabelAndInput}
								label='Inclusão' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'} />}

							{(this.props.formularioValues.nome_usuario_alteracao 
							&& (this.props.formularioValues.nome_usuario_alteracao != this.props.formularioValues.nome_usuario_inclusao)) &&
							<Field
								name='nome_usuario_alteracao'
								component={LabelAndInput}
								label='Alteração' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'} />}
								
						</Row>
					</ContentCardBody>
					
					<ContentCardFooter>
						<Row alignCenter>
							{!this.props.excluir &&
							<>
								<Grid cols='6 6 4 3'>
									<Button
										text='Salvar'
										type={'success'}
										icon={'fa fa-check'}
										event={() => {
											this.props.salvar({
												...this.props.formularioValues
											}, false);
										}} />
								</Grid>
								{!this.props.formularioValues.id &&
								<Grid cols='6 6 4 3'>
									<Button
										text='Salvar e continuar'
										type={'success'}
										icon={'fa fa-check'}
										event={() => {
											this.props.salvar({
												...this.props.formularioValues
											}, true);
										}} />
								</Grid>}
							</>}
							{this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Excluir'
									submit type={'danger'}
									icon={'fa fa-trash'} />
							</Grid>}
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>

			</ContentCard>
		);
    }


}

DespesaForm = reduxForm({form: 'despesaForm', destroyOnUnmount: false})(DespesaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('despesaForm')(state),
	registro: state.despesa.registro,
	listaEmpresa: state.empresa.listaSelect,
	listaCentroCusto: state.centroCusto.listaSelect,
	listaFornecedor: state.fornecedor.listaSelect,
	listaAnalitica: state.analitica.listaSelect,
	listaFormaPagamento: state.formaPagamento.listaSelect.filter(item => item.despesa),
	listaOrigem: state.destinatario.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(DespesaForm);
